import { ref } from 'vue'
import { useServicesStore } from '@/stores/services'

export function useBottomBarTime() {
    const hours = ref(0)
    const zhours = ref(0)
    const minutes = ref('')

    const serv = useServicesStore()

    const updateTime = () => {
        const now = new Date()
        hours.value = now.getHours()
        zhours.value = now.getUTCHours()
        minutes.value = now.getMinutes().toString().padStart(2, '0')
        serv.dispatchGetUnitsOnline()
    }

    const parseUtcString = (utcStr: string) => {
        // Convierte "2025-06-13 16:57:50.009" a "2025-06-13T16:57:50.009Z"
        return new Date(utcStr.replace(' ', 'T') + 'Z')
    }

    return {
        hours,
        zhours,
        minutes,
        updateTime,
        parseUtcString
    }
}
